import products from "../../test_data/basket/products";
import { requestHelpers } from '../../helpers';

const actions = {
    CLEAR_BASKET: 'CLEAR_BASKET',
    ADD_TO_BASKET: 'ADD_TO_BASKET',
    GET_ALL_PRODUCTS: 'GET_ALL_PRODUCTS',
    SET_ALL_PRODUCTS: 'SET_ALL_PRODUCTS',
    REMOVE_FROM_BASKET: 'REMOVE_FROM_BASKET',
    GET_BASKET_PRODUCTS: 'GET_BASKET_PRODUCTS',
    CHECKOUT_REQUEST: 'CHECKOUT_REQUEST',
    CHECKOUT_SUCCESS: 'CHECKOUT_SUCCESS',
    CHECKOUT_FAILURE: 'CHECKOUT_FAILURE',
    GET_ALL_PACKAGES: 'GET_ALL_PACKAGES',
    SET_ALL_PACKAGES: 'SET_ALL_PACKAGES',
};

function clearBasket() {
    return ( dispatch ) => {
        dispatch({
            type: actions.CLEAR_BASKET,
            products,
        });
    }
}

export function addProductToBasket( product ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.ADD_TO_BASKET,
            product,
        } );
    }
}

export function getAllProducts() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_ALL_PRODUCTS,
        } );

        requestHelpers
            .authenticatedGetRequest( `/transactions/products` )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_ALL_PRODUCTS,
                    products: response.data,
                } );
            } );
    }
}

export function getAllPackages( ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_ALL_PACKAGES,
        } );

        requestHelpers
            .authenticatedGetRequest( `/transactions/packages` )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_ALL_PACKAGES,
                    packages: response.data,
                } );
            } );
    }
}

export function removeProductFromBasket( product ) {
    return ( dispatch ) => {
        dispatch({
            type: actions.REMOVE_FROM_BASKET,
            product,
        });
    };
}

export function getBasketProducts() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_BASKET_PRODUCTS,
        } );
    };
}

module.exports = {
    getAllProducts,
    getAllPackages,
    addProductToBasket,
    removeProductFromBasket,
    getBasketProducts,
    clearBasket,
    actions,
};



// WEBPACK FOOTER //
// src/client/actions/basket/basket.js